import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"

import "./Search.vue?vue&type=style&index=0&id=c25a28ca&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\arm_analysis_2025_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c25a28ca"]])

export default __exports__